import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Participant } from '../model/participant';

@Injectable()
export class ParticipantService {
    constructor(private http: HttpClient) { }

    private buildUrl(hash: string): string {
        return `${environment.api}/forms/participants/${hash}`;
    }

    getParticipant(hash: string) {
        return this.http.get<Participant>(this.buildUrl(hash));
    }

    updateParticipant(hash: string, participant: Participant) {
        return this.http.put<void>(this.buildUrl(hash), participant);
    }
}
